var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 76,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C4AB73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 13.17v2.792L38.596 8.226c-5.074-2.905-12.155-2.905-17.191 0L8 16v-2.83C8 4.68 12.658 0 21.177 0h17.646C47.343 0 52 4.68 52 13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.73 22.828-.533-.266-5.177-2.958-10.734-6.182c-3.274-1.896-8.298-1.896-11.572 0L12.98 19.566 7.803 22.6l-.685.342C.457 27.417 0 28.252 0 35.419v17.143c0 7.168.457 8.002 7.27 12.591l16.444 9.444C25.351 75.583 27.407 76 29.5 76c2.055 0 4.149-.455 5.786-1.403l16.596-9.558C58.582 60.564 59 59.768 59 52.562V35.419c0-7.168-.457-8.002-7.27-12.591ZM40.12 43.8l-2.322 2.844c-.38.417-.647 1.214-.609 1.783l.228 3.64c.153 2.238-1.446 3.376-3.54 2.58l-3.387-1.366c-.533-.19-1.409-.19-1.942 0l-3.387 1.328c-2.094.834-3.693-.342-3.54-2.58l.228-3.64c.038-.569-.228-1.365-.609-1.783l-2.36-2.806c-1.447-1.707-.8-3.603 1.37-4.172l3.54-.91c.571-.152 1.218-.683 1.523-1.138l1.98-3.034c1.217-1.896 3.159-1.896 4.415 0l1.98 3.034c.304.493.989.986 1.522 1.138l3.54.91c2.17.569 2.816 2.465 1.37 4.172Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy3);
export default __webpack_public_path__ + "static/media/why_3.bb55bb18caded106bdbc60c2a5d616c4.svg";
export { ForwardRef as ReactComponent };